module.exports = __webpack_public_path__ + "static/img/hayward-nav.fc07ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/hayward-nav.png
// module id = FE0V
// module chunks = 4